<template>
    <div class="filter_container locator__top-bar-promotions__item" v-bind:class="{'dropdown-item}': isDropdown}">
        <div class="locator__top-bar-promotion">
            <input class="locator__top-bar-promotion-input" type="checkbox"
                   v-model="promotionSelected"
                   :disabled="otherPromoIsSelected && !this.promotionSelected"
            >
            <label class="locator__top-bar-promotion-label" for="">
                <small v-if="smallTitle" class="locator__top-bar-promotion-heading" v-html="smallTitle"></small>
                <h4 class="locator__top-bar-promotion-desc"
                    :class="{ 'locator__top-bar-promotion-desc-short-view' : shortView }"
                    v-html="promotionData.name"></h4>
            </label>
        </div>
    </div>
</template>

<script>
    import EventBus from '../eventBus'

    export default {
        name: "promo-btn",
        props: ['promotionData', 'otherPromoIsSelected', 'isDropdown'],
        data() {
            return {
                promotionSelected: false,
                selfStateChange: false
            }
        }, mounted() {
            let that = this;
            EventBus.$on('MAP_READY', (payload) => {
                if (payload.promotionSelected.id == that.promotionData.id) {
                    that.promotionSelected = true;
                }
            })
        },
        computed: {
            shortView() {
                if (this.promotionData.locator_heading) {
                    return false;
                }
                return true;
            },
            smallTitle() {
                if (!this.promotionData) return '';
                return this.promotionData.locator_heading || this.$t('only_with');
            }
        },
        watch: {
            '$store.state.selectedPromotionsInit'(promotions) {
                // if(this.selfStateChange) return;
                // console.log('button select');
                setTimeout(() => {
                    for (let promotion of promotions) {
                        if (Array.isArray(promotion)) {
                            for (let promotion1 of promotion) {
                                if (promotion1 == this.promotionData.id) {
                                    this.promotionSelected = true;
                                    return;
                                }
                            }
                        } else {
                            if (promotion == this.promotionData.id) {
                                this.promotionSelected = true;
                                return;
                            }
                        }
                    }
                })

            },
            promotionSelected(val) {
                this.selfStateChange = true;
                this.$emit('input', val);
                if (val) {
                    this.$emit('promotionSelected', this.promotionData)
                } else {
                    const currentUrl= window.location.href;
                    const regex = /promotion=[0-9]+\&?/;
                    const newUrl = currentUrl.replace(regex, '');

                    window.history.pushState({}, document.title, newUrl);
                    this.$emit('promotionUnselected', this.promotionData)
                }

            }
        }
    }
</script>

<style lang="scss" scoped>
    .locator__top-bar-promotion {
        display: flex;
        align-self: center;
        margin-right: 30px;
    }

    .locator__top-bar-promotion-input {
        flex-shrink: 0;
        position: relative;
        width: 21px;
        height: 21px;
        margin-right: 10px;
        align-self: center;
        -webkit-appearance: none;
        border: none;
        border-radius: 0;

        &:before {
            content: '';
            position: absolute;
            width: 100%;
            height: 100%;
            background: white;
        }

        &:checked:before {
            background: red;
        }
    }

    .locator__top-bar-promotion-label {
        display: flex;
        flex-flow: column;
        color: white;
        line-height: 15px;
        font-size: 13px;
    }

    .locator__top-bar-promotion-heading {
        font-style: oblique;
        font-weight: 300;
        font-size: inherit;
    }

    .locator__top-bar-promotion-desc {
        margin: 0;
        text-transform: uppercase;
        font-weight: 700;
        color: white;

        &-short-view {
            line-height: 21px;
        }
    }

    .filter_container {
        display: flex;
        align-items: center;
    }

    .dropdown {
        .filter_container {
            margin-top: 12px;

            &:first-of-type {
                margin-top: 0;
            }
        }
    }


</style>
